import {
  FAIL,
  THIRD_PARTY_SEARCH,
  INCREMENT_THIRD_PARTY_SEARCH_PAGE,
  SET_THIRD_PARTY_SEARCH_QUERY,
  START,
  SUCCESS
} from "../constants/action-types";
import {apiGoogleSearchTemplate, shutterStockSearch} from "../constants/api";

export const setSearchQuery = (query = ``) => ({
  type: SET_THIRD_PARTY_SEARCH_QUERY,
  payload: {query}
});

export const clearSearchData = () => ({
  type: SET_THIRD_PARTY_SEARCH_QUERY,
  payload: {query: ``, data: []}
});

export const incrementThirdPartySearchPage = () => {
  return {
    type: INCREMENT_THIRD_PARTY_SEARCH_PAGE
  };
};

const getAPIParamsForQuery = (query) => {
  const totalPages = 5;
  const pages = new Array(totalPages).fill(0).map((_, i) => 10 * i + 1);
  const imageSizes = [`huge`, `xxlarge`, `xlarge`, `large`];
  const params = imageSizes
    .map((imgSize) => ({...query, imgSize}))
    .reduce((acc, searchQuery) => {
      return [...acc, ...pages.map((start) => ({...searchQuery, start}))];
    }, []);
  return params;
};

const getImageData = (url) => {
  return fetch(url)
    .then((res) => res.json())
    .catch((err) => {
      throw err;
    });
};

const searchInGoogle = () => (dispatch, getState) => {
  (async () => {
    try {
      const {
        uploader: {query, page}
      } = getState();
      const arrayOfParams = getAPIParamsForQuery({
        value: query,
        color: ``,
        type: ``
      });
      const data = await getImageData(
        apiGoogleSearchTemplate(arrayOfParams[page])
      );
      dispatch({
        type: THIRD_PARTY_SEARCH + SUCCESS,
        payload: {
          data
        }
      });
    } catch (error) {
      dispatch({
        type: THIRD_PARTY_SEARCH + FAIL,
        error
      });
      throw error;
    }
  })();
};

const searchInShutterStock = () => (dispatch, getState) => {
  const {
    uploader: {query, page}
  } = getState();

  shutterStockSearch({query, page: page + 1})
    .then((result) => {
      dispatch({
        type: THIRD_PARTY_SEARCH + SUCCESS,
        payload: {
          data: result
        }
      });
    })
    .catch((error) => {
      dispatch({
        type: THIRD_PARTY_SEARCH + FAIL,
        error
      });
    });
};

export const search = () => (dispatch, getState) => {
  const {
    uploader: {source}
  } = getState();

  dispatch({
    type: THIRD_PARTY_SEARCH + START
  });

  if (source === `google-search`) {
    dispatch(searchInGoogle());
  }

  if (source === `shutterstock`) {
    dispatch(searchInShutterStock());
  }
};
